import apiUrl from "./config/config";
import axios from "axios";

class reportApi {

  //Get all reports
  static async getReports(params = {})
  {

    try
    {

      const response = await axios(apiUrl + "report", { params });

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }

  //Get a report by id
  static async getReport(id)
  {

    try
    {

      const response = await axios(apiUrl + `report/${id}`);

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }


  //Update a report
  static async updateReport(params)
  {

    try
    {

      const response = await axios.post(apiUrl + "report", params);

      return response.data;

    } catch (err)
    {

      throw new Error(err);

    }

  }


  //Get all reports statuses
  static async getReportStatuses(params = {})
  {

    try
    {

      const response = await axios(apiUrl + "report/status", { params });

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }

  //Update a report status
  static async updateReportStatus(params)
  {

    try
    {

      const response = await axios.post(apiUrl + "report/status", params);

      return response.data;

    } catch (err)
    {

      throw new Error(err);

    }

  }

}







export default reportApi;
